<template>
    <div>{{ from }} t/m {{ to }} van {{ total | numberFormatNL }} {{ name }}</div>
</template>

<script>
export default {
    props: {
        info: Object,
        from: Number,
        to: Number,
        total: Number,
        name: {
            Type: String,
            Default: "items"
        }
    }
};
</script>
